import React from 'react';
import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './popover';

/**
 * Small "How we calculate" info-icon button.
 * Click to reveal a popover containing the exact formula and methodology notes.
 *
 * Usage:
 *   <MethodologyInfo title="SIP Formula">
 *     <p>FV = P × ...</p>
 *   </MethodologyInfo>
 */
const MethodologyInfo = ({ title = 'How we calculate', children, testId }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        data-testid={testId}
        className="inline-flex items-center gap-1 text-xs sm:text-sm text-white/90 hover:text-white underline-offset-2 hover:underline"
        title="How we calculate"
      >
        <Info size={14} />
        <span>How we calculate</span>
      </button>
    </PopoverTrigger>
    <PopoverContent
      side="bottom"
      align="end"
      className="w-[320px] sm:w-[400px] text-sm leading-relaxed bg-white"
    >
      <p className="font-bold text-slate-900 mb-2">{title}</p>
      <div className="text-slate-700 space-y-2">{children}</div>
    </PopoverContent>
  </Popover>
);

export default MethodologyInfo;
